import React, { useEffect, useRef, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import { modalSideService } from "../services/modalSideService";
import { Colors } from "../assets/colors/Colors";
import InputForm from "./ComponentesFormularios/InputForm";
import CheckBox from "./ComponentesFormularios/CheckBox";
import { convertToString, validArray, validObjectKeys } from "../util/functions";
import Emitter from "../EventEmitter/EventEmitter";
import { ConstantEventEmitter } from "../data/ConstantEventEmitter";
import { ModalSide } from "./ModalSide";
import { ConstantsFormCrud } from "../data/RoutesFormCrud";
import { isEmpty } from "../util/is";

let SUCCESS = "1";
let ERROR = "0";
let UPDATED = "2";

const Pills = ({ allDataSuccess, allDataError, allDataUpdated, showUpdated }) => {

    const [statePills, setStatePills] = useState(SUCCESS);

    const handleChangePills = (state) => {

        setStatePills(state);
        Emitter.emit("handleChangePill", state);

    }

    return (
        <div style={{ alignItems: "center" }}>
            <div className="card w-100" style={{ borderRadius: 55 }}>
                <div style={{ position: "relative", flexDirection: "row", alignItems: "center", height: "100%" }}>
                    <div className="d-flex" style={{ width: "100%", backgroundColor: Colors.GRAY_LOW, height: 40, borderRadius: 20 }}>
                        <div onClick={() => handleChangePills(SUCCESS)} className="d-flex flex-column justify-content-center cursor-pointer" style={{
                            width: "50%", borderRadius: 50,
                            backgroundColor: statePills === SUCCESS ? Colors.GREEN_SWITCH_ACTIVE : "transparent"
                        }}>
                            <p className="m-0" style={{ textAlign: "center", fontWeight: "bold", color: statePills === SUCCESS ? Colors.WHITE : Colors.DARK_GRAY }}>{ showUpdated ? 'Creados' : 'Exitosos'} ({Object.keys(validObjectKeys(allDataSuccess))?.length})</p>
                        </div>
                        {
                            !showUpdated &&
                            <div onClick={() => handleChangePills(ERROR)} className="d-flex flex-column justify-content-center cursor-pointer" style={{
                                width: "50%", borderRadius: 50,
                                backgroundColor: statePills === ERROR ? Colors.RED_SWITCH_INACTIVE : "transparent"
                            }}>
                                <p className="m-0" style={{ textAlign: "center", fontWeight: "bold", color: statePills === ERROR ? Colors.WHITE : Colors.DARK_GRAY }}>Errores ({Object.keys(validObjectKeys(allDataError))?.length})</p>
                            </div>
                        }
                        {
                            showUpdated &&
                            <div onClick={() => handleChangePills(UPDATED)} className="d-flex flex-column justify-content-center cursor-pointer" style={{
                                width: "50%", borderRadius: 50,
                                backgroundColor: statePills === UPDATED ? Colors.COLOR_BLUE_THEME : "transparent"
                            }}>
                                <p className="m-0" style={{ textAlign: "center", fontWeight: "bold", color: statePills === UPDATED ? Colors.WHITE : Colors.DARK_GRAY }}>Actualizados ({Object.keys(validObjectKeys(allDataUpdated))?.length})</p>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

const UploadFileModalList = ({ properties }) => {

    const { data: datos, datosSuccess, datosError, datosUpdated = {},showUpdated = false, descripcion, title, keyId, keyLabel } = properties;
    // const {data: datos, datosSuccess, datosError, descripcion, title, keyId, keyLabel} = properties;
    const [stateFilter, setStateFilter] = useState("");
    const [allDataSuccess, setAllDataSuccess] = useState(datosSuccess);
    const [allDataError, setAllDataError] = useState(datosError);
    const [allDataUpdated, setAllDataUpdated] = useState(datosUpdated);
    const [allData, setAllData] = useState(validArray(datos).slice());
    const [data, setData] = useState(validArray(datos).slice());
    const statePills = useRef(SUCCESS);

    const handleChangeInput = value => {

        setStateFilter(value);
        if (statePills.current === SUCCESS) {
            setData(allData?.filter(x =>
                (convertToString(x[keyId])?.toUpperCase()?.includes(convertToString(value)?.toUpperCase()) ||
                    convertToString(x[keyLabel])?.toUpperCase()?.includes(convertToString(value)?.toUpperCase()))
                && allDataSuccess[convertToString(x[keyId])]).map(item => ({
                    ...item, msg: allDataSuccess[convertToString(item[keyId])]?.msg
                    , errorHijos: allDataSuccess[convertToString(item[keyId])]?.errorHijos
                })));
        }
        else {
            if (showUpdated) {
                setData(allData?.filter(x =>
                    (convertToString(x[keyId])?.toUpperCase()?.includes(convertToString(value)?.toUpperCase()) ||
                        convertToString(x[keyLabel])?.toUpperCase()?.includes(convertToString(value)?.toUpperCase()))
                    && allDataUpdated[convertToString(x[keyId])]).map(item => ({
                        ...item, msg: allDataUpdated[convertToString(item[keyId])]?.msg
                        , errorHijos: allDataUpdated[convertToString(item[keyId])]?.errorHijos
                    })));
            }
            else {

                setData(allData?.filter(x =>
                    (convertToString(x[keyId])?.toUpperCase()?.includes(convertToString(value)?.toUpperCase()) ||
                        convertToString(x[keyLabel])?.toUpperCase()?.includes(convertToString(value)?.toUpperCase()))
                    && allDataError[convertToString(x[keyId])]).map(item => ({
                        ...item, msg: allDataError[convertToString(item[keyId])]?.msg
                        , errorHijos: allDataError[convertToString(item[keyId])]?.errorHijos
                    })));
            }
        }


    }

    const handleChangePill = (state) => {

        setStateFilter("");
        statePills.current = state;
        if (state === SUCCESS) {

            setData(
                allData?.filter(x => allDataSuccess[convertToString(x[keyId])]).map(item => ({
                    ...item, msg: allDataSuccess[convertToString(item[keyId])]?.msg,
                    errorHijos: allDataSuccess[convertToString(item[keyId])]?.errorHijos
                }))
            );

        }
        else {

            if (showUpdated) {
                setData(
                    allData?.filter(x => datosUpdated[convertToString(x[keyId])]).map(item => ({
                        ...item, msg: datosUpdated[convertToString(item[keyId])]?.msg,
                        errorHijos: datosUpdated[convertToString(item[keyId])]?.errorHijos
                    }))
                );
            }
            else {

                setData(
                    allData?.filter(x => allDataError[convertToString(x[keyId])]).map(item => ({
                        ...item, msg: allDataError[convertToString(item[keyId])]?.msg,
                        errorHijos: allDataError[convertToString(item[keyId])]?.errorHijos
                    }))
                );
            }


        }

    }

    const handleViewErrorDatailProductsVirtuales = (objErrorProductosVirtuales, idPadre, nmPadre) => {

        modalSideService.showModal({
            props: {
                data: objErrorProductosVirtuales,
                descripcion: `Aqui podrás visualizar y buscar los productos virtuales que generaron error al cargar el excel del producto ${idPadre} - ${nmPadre}`,
                title: `Total de productos (${Object.keys(objErrorProductosVirtuales).length})`,
            },
            type: ConstantsFormCrud.modalSIDEUploadFileProductosViewErrorsDetailProductosVirtuales,
            title: `Información errores productos virtuales del padre ${idPadre} - ${nmPadre}`,
            isAddMode: false,
            isEditable: true,
            dense: true,
            id: "modalDetailErroresProductosVirtuales",
            size: `xl`
        });

    }

    useEffect(() => {

        setData(
            allData?.filter(x => allDataSuccess[convertToString(x[keyId])]).map(item => ({
                ...item, msg: allDataSuccess[convertToString(item[keyId])]?.msg,
                errorHijos: allDataSuccess[convertToString(item[keyId])]?.errorHijos
            }))
        );

    }, [])

    useEffect(() => {
        return () => {
            Emitter.off("handleChangePill");
        }
    }, [])

    useEffect(() => {
        Emitter.on("handleChangePill", (state) => handleChangePill(state));
    }, [])

    return (
        <div className="p-2">

            <div className="mb-3 d-flex align-items-center justify-content-end">

                {!showUpdated &&
                    <Tooltip title="Cerrar" aria-label="cerrar">
                    <a onClick={() => modalSideService.clear()} className="icon-container-actions d-flex mr-0">
                        <div style={{ backgroundColor: Colors.RED_SWITCH_INACTIVE }} />
                        <i style={{ color: Colors.RED_SWITCH_INACTIVE }} className="fas fa-times fa-2x" />
                    </a>
                </Tooltip>}
            </div>

            <p className="mb-0 text-justify">{descripcion}</p>

            <InputForm identificador={`filterList`} label={``} value={stateFilter}
                placeholder="Buscar..." type="text" className={`px-0 col-12`} handleChange={({ name, value }) => handleChangeInput(value)}
            />


            <p className="font-weight-bold mt-2">{title}</p>

            <Pills allDataSuccess={allDataSuccess} allDataError={allDataError} allDataUpdated={allDataUpdated} showUpdated={showUpdated} />

            <div className="px-0 col-12">

                {
                    data?.map((item, index) => (
                        <div className="my-1" key={`key${item[keyId]}${index}`} >
                            <div className="d-flex align-items-center justify-content-between p-1">

                                <div className="d-flex align-items-center">
                                    <Tooltip title={item.msg || ""}>
                                        <i className="fas fa-info-circle fa-lg cursor-pointer" style={{ color: Colors.COLOR_BLUE_THEME }} />
                                    </Tooltip>

                                    <div className="d-flex align-items-center mx-2">
                                        {
                                            !isEmpty(keyId) && !isEmpty(keyLabel) ?
                                                <>
                                                    {item[keyId]} - {item[keyLabel]}
                                                </>
                                                :
                                                <>
                                                    {item[keyId]}
                                                </>
                                        }

                                    </div>
                                </div>

                                {
                                    Object.keys(validObjectKeys(item?.errorHijos)).length > 0 &&
                                    <Tooltip title={"Ver errores productos virtuales"}>
                                        <i onClick={() => handleViewErrorDatailProductsVirtuales(validObjectKeys(item?.errorHijos), item[keyId], item[keyLabel])} className="fas fa-exclamation-triangle fa-lg cursor-pointer" style={{ color: Colors.ORANGE }} />
                                    </Tooltip>
                                }


                            </div>
                        </div>
                    ))
                }

            </div>

            <ModalSide id="modalDetailErroresProductosVirtuales" />

        </div>

    )

}

export default UploadFileModalList;
